<style scoped>
.content {
  /* height: 100%; */
}
.left-content {
  width: 20%;
  height: 100%;
  padding: 20px;
  margin-right: 10px;
  background: #fff;
  border-radius: 4px;
}
.rate-box {
  height: 77px;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
}
.rate-top {
  display: flex;
  justify-content: space-between;
}
.title-box {
  font-size: 16px;
}
.operation {
  font-size: 14px;
  color: blue;
}
.double-num {
  font-size: 20px;
  color: red;
  margin-top: 10px;
}
.text-num {
  font-size: 16px;
}
.right-content {
  flex: 1;
  overflow: hidden;
}
.el-col-5 {
  width: 26%;
}
.el-drawer {
  overflow-y: auto;
}
.el-drawer__body {
  padding: 0 40px;
}

.batch {
  display: flex;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 0 10px;
  margin-bottom: 30px;
  background: #ddecef;
  border-radius: 4px;
}
.batch img {
  margin-right: 10px;
}
.rate {
  display: flex;
}
.rate-left {
  width: 145px;
  flex-shrink: 0;
}
.rate-right {
  width: 100%;
}
.el-table--border th.gutter:last-of-type {
  display: block !important;
}
</style>
<template>
  <div class="content">
    <div class="right-content">
      <div class="search-area">
        <el-row :gutter="24">
          <el-col :span="5"
            ><div class="search-area-div">商品：</div>
            <el-input v-model="page.goodsName" class="ipt-sty" placeholder="请输入" :clearable="true"></el-input
          ></el-col>
          <el-col :span="5"
            ><div class="search-area-div">收费状态：</div>
            <el-select v-model="page.chargeState" placeholder="请选择" class="ipt-sty" :clearable="true">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option> </el-select
          ></el-col>
          <el-col :span="5">
            <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
            <el-button size="medium" type="danger" @click="empty()">清空</el-button>
          </el-col>
        </el-row>
      </div>
      <div class="button-area">
        <el-button size="medium" @click="batchSupplierRate">批量设置费率</el-button>
        <el-button size="medium" @click="batchStopCharge">批量停止收费</el-button>
        <el-button size="medium" @click="goodsExport">导出</el-button>
      </div>
      <div class="back-color-fff p16">
        <el-table :data="goodsRateData" @selection-change="handleSelectionChange" border v-loading="loading">
          <el-table-column
            type="selection"
            width="40"
            header-align="center"
            align="center"
            :selectable="selectEnable"
          ></el-table-column>
          <el-table-column label="序号" width="60" header-align="center" align="center">
            <template slot-scope="scope">
              {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
            </template>
          </el-table-column>
          <el-table-column
            prop="goodsName"
            label="商品"
            min-width="300"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="goodsSpec"
            label="规格"
            width="150"
            header-align="center"
            align="left"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column prop="rateType" label="费率方式" width="120" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.isSet" v-model="scope.row.rateType" placeholder="请选择">
                <el-option v-for="item in rateTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span v-else>{{ scope.row.rateType | getRateType }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="费率（％）" width="100" header-align="center" align="center">
            <template slot-scope="scope">
              <!-- <span v-if="scope.row.isSet && scope.row.rateType == '1'">{{ defaultRate | numDigit }}</span> -->
              <el-input
                v-if="scope.row.isSet && scope.row.rateType == '2'"
                placeholder="请输入"
                type="text"
                v-model="scope.row.rate"
              ></el-input>
              <span v-if="scope.row.rateType == '3'">-</span>
              <!-- <span v-if="!scope.row.isSet && scope.row.rateType == '1'">{{ scope.row.rate }}</span> -->
              <span v-if="!scope.row.isSet && scope.row.rateType == '2'">{{ scope.row.rate | numDigit}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="chargeState" label="收费状态" width="105" header-align="center" align="center">
            <template slot-scope="scope">
              <el-select v-if="scope.row.isSet" v-model="scope.row.chargeState" placeholder="请选择" :clearable="true">
                <el-option v-for="item in chargeStateList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
              <span v-else>{{ scope.row.chargeState | getChargeState }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startChargeDate" label="开始收费时间" width="155" header-align="center" align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.isSet"
                v-model="scope.row.startChargeDate"
                size="small"
                type="date"
                placeholder="选择日期"
                style="width: 130px"
              >
              </el-date-picker>
              <span v-else>{{ scope.row.startChargeDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="stopChargeDate" label="停止收费时间" width="155" header-align="center" align="center">
            <template slot-scope="scope">
              <el-date-picker
                v-if="scope.row.isSet"
                v-model="scope.row.stopChargeDate"
                size="small"
                type="date"
                placeholder="选择日期"
                style="width: 130px"
              >
              </el-date-picker>
              <span v-else>{{ scope.row.stopChargeDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="updateUserName" label="维护人" width="150" header-align="center" align="center">
          </el-table-column>
          <el-table-column prop="updateTime" label="最后维护时间" width="155" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.updateTime | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="startFeesDate" label="开始计费时间" width="155" header-align="center" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.startFeesDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="recentlyFeesDate"
            label="最近计费时间"
            width="155"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.recentlyFeesDate | getDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" header-align="center" width="170" align="center">
            <template slot-scope="scope">
              <a class="txt-color" @click="goodsEdit(scope.row, scope.$index)"
                >{{ scope.row.isSet ? '保存' : '编辑' }} |
              </a>
              <a class="txt-color" @click="getGoodsHistoryRateList(scope.row)">查看历史</a>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        class="pt pb back-color-fff"
        style="padding: 16px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
    <el-dialog title="商品费率历史" :visible.sync="dialogTableVisible">
      <el-table :data="supplierGoodsRateList">
        <el-table-column property="goodsName" label="商品"  header-align="center" align="center"></el-table-column>
        <el-table-column property="rateType" label="费率方式" header-align="center" align="center">
         <template slot-scope="scope">{{ scope.row.rateType | getRateType }}</template>
         </el-table-column>
        <el-table-column property="rate" label="费率(％)" header-align="center" align="center">
        <template slot-scope="scope"> {{ scope.row.rate*100 | numDigit }} </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt pb back-color-fff"
        style="padding: 16px"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 100, 200]"
        :current-page="page1.pageIndex"
        :page-size="page1.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page1.totalRows"
      >
      </el-pagination>
    </el-dialog>
    <el-dialog title="批量设置费率" :visible.sync="dialogVisible1" width="30%">
      <div class="batch">
        <img width="25" class="fl" src="../../assets/images/remind1.png" />
        <p>费率方式为“自定义费率”时，才能批量设置</p>
      </div>
      <div class="rate">
        <div class="rate-left">账号缺省费率（％）：</div>
        <div class="rate-right">
          <el-input v-model="customRate" placeholder="请输入"></el-input>
          <p class="t-left">大写：百分之</p>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible1 = false">取 消</el-button>
        <el-button size="medium" type="info" @click="setBatchRate">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="批量停止收费" :visible.sync="dialogVisible2" width="30%">
      <div class="batch">
        <img width="25" class="fl" src="../../assets/images/remind1.png" />
        <p>费率方式为“自定义费率”时，才能批量设置</p>
      </div>
      <div class="rate">
        <div class="rate-left rate-stop">停止收费时间：</div>
        <div class="rate-right">
          <el-date-picker v-model="stopChargeDate" type="date" style="width: 100%" placeholder="选择日期">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible2 = false">取 消</el-button>
        <el-button size="medium" type="info" @click="setStopChargeDate">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible1: false,
      //费率方式
      rateTypeList: [
        { value: '2', label: '自定义费率' },
        { value: '3', label: '不计费' },
      ],
      //收费状态
      chargeStateList: [
        { value: 'Y', label: '正常' },
        { value: 'S', label: '停止收费' },
        { value: 'N', label: '不计费' },
      ],
      showEdit: true,
      dialogVisible2: false,
      dialogTableVisible:false,
      drawer: false,
      direction: 'rtl',
      fileList: [],
      numRate: 0,
      rateInput: false,
      rateShow: true,
      stopChargeDate: '',
      tableDataList: [],
      customRate: 0,
      multipleSelection: [],
      input: '',
      value1: '',
      value2: '',
      page1: {
        pageIndex: 1,
        pageSize: 5,
        totalPage: 0,
        totalRows: 0,  
        supplierRateGuid: '',
        goodsGuid:'',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        chargeState: '',
        goodsName: '',
        supplierRateGuid: '',
      },
      options: [
        {
          value: 'Y',
          label: '正常',
        },
        {
          value: 'S',
          label: '停止收费',
        },
        {
          value: 'N',
          label: '不收费',
        },
      ],
      value: '',
      goodsRateData: [],
      loading: false,
      defaultRate: 0,
      supplierGoodsRateList:[],
    };
  },
  created() {
    // 列表
    this.addJudge();
    this.getGoodsRateList(false);
    // this.getDefaultRate();
  },
  // beforeRouteLeave(to, from, next) {
  //   //跳转到搜索页面时，search为搜索页面名称
  //   if (to.name == 'goodsRate') {
  //     to.meta.isBack = true;
  //   }

  //   next();
  // },
  methods: {
    getDetails(row) {
      console.log(row); //此时就能拿到整行的信息
    },
    getGoodsHistoryRateList(row){
          this.dialogTableVisible = true;
          this.getHistoryRateList(true,row.goodsGuid,row.supplierRateGuid)
    },
    getHistoryRateList(flg,goodsguid,supplierrateguid) {
      let self = this;
      self.loading = true;
      if (flg) {
        self.page1.pageIndex = 1;
      } 
      let goodsGuid = goodsguid;
      let pageIndex = self.page1.pageIndex;
      let pageSize = self.page1.pageSize;
      let supplierRateGuid = supplierrateguid;
        self.api.get(`/ms-data-business-service/rate/get-supplier-goods-history-rate-list?goodsGuid=` +
              goodsGuid +
              `&pageIndex=` +
              pageIndex +
              `&pageSize=` +
              pageSize +
              `&supplierRateGuid=` +
              supplierRateGuid 
          )
          .then((res) => {
            self.loading = false;
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
              self.supplierGoodsRateList = res.data.data.records;
              self.page1.totalPage = res.data.data.totalPages;
              self.page1.totalRows = res.data.data.totalRows;
            } else {
              self.$message.error(res.data.msg);
            }
          });
    },
    addJudge() {
      let self = this;
      self.goodsRateData.forEach((value, index) => {
        value['isSet'] = false;
      });
    },
    // 搜索
    searchData() {
      let self = this;
      self.getGoodsRateList(true);
    },
    //清空
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        supplierRateGuid: self.$route.query.guid,
        goodsName: '',
        chargeState: '',
      };
      self.getGoodsRateList(true);
    },
    //查询缺省费率
    // getDefaultRate() {
    //   let self = this;
    //   self.api.get('/ms-data-business-service/rate/select-rate').then((res) => {
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.defaultRate = res.data.data.rate * 100;
    //       self.DefaultRateGuid = res.data.data.guid;
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    //保存时将供应商信息保存
    toSaveSupplier() {
      let self = this;
      let editSupplier = self.$route.query.row;
      delete editSupplier.isSet;
      self.api.postJson('/ms-data-business-service/rate/update-supplier-rate-info', editSupplier).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },

    // 导出
      goodsExport() {
      let supplierName = this.$route.query.supplier;
      let supplierRateGuid=this.$route.query.guid
      let { goodsName, chargeState} = this.page;
      this.api
        .post(
          `/ms-data-business-service//rate/mf-supplier-goods-rate-export?` +
          `goodsName=` +
          goodsName +
          `&chargeState=` +
          chargeState +
          `&supplierRateGuid=` +
          supplierRateGuid +
          `&supplierName=` +
          supplierName,
        ).then(res => {
          if (res.data.code == '00000') {
            this.api
              .postJsonD(`ms-common-admin-cloud-service/excel/export`, res.data.data).then(res => {
                let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                let fileName = '商品信息';
                let objectUrl = URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.download = fileName;
                link.href = objectUrl;
                link.click();
              })
          }
        })
    },
    //获取供应商商品信息
    getGoodsRateList(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.loading = true;
      let chargeState = self.page.chargeState;
      let pageIndex = self.page.pageIndex;
      let pageSize = self.page.pageSize;
      let goodsName = self.page.goodsName;
      let supplierRateGuid = self.$route.query.guid;
      return new Promise((resolve, reject) => {
        self.api
          .get(
            `/ms-data-business-service/rate/get-supplier-goods-rate-list?chargeState=` +
              chargeState +
              `&goodsName=` +
              goodsName +
              `&pageIndex=` +
              pageIndex +
              `&pageSize=` +
              pageSize +
              `&supplierRateGuid=` +
              supplierRateGuid,
          )
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.loading = false;
              self.goodsRateData = res.data.data.list;
              self.goodsRateData.forEach((value, index) => {
                value['isSet'] = false;
                value.rate = (value.rate * 100).toFixed(2);
              });
              self.page.totalPage = res.data.data.totalPages;
              self.page.totalRows = res.data.data.totalRows;
              resolve(true);
              console.log(res.data);
            } else {
              self.goodsRateData = [];
              self.$message.error(res.data.msg);
            }
          });
      });
    },
    //是否禁用多选框
    selectEnable(row, rowIndex) {
      if (row.rateType !== '2') {
        return false;
      } else {
        return true; // 不禁用
      }
    },
    //批量设置费率弹窗
    batchSupplierRate() {
      let self = this;
      if (self.multipleSelection.length == 0) {
        self.$message.error('请先勾选数据');
        return;
      } else {
        self.dialogVisible1 = true;
      }
    },
    //批量设置费率确定
    setBatchRate() {
      let self = this;
      let reg = /^\d+(\.\d{1,2})?$/;
      if (reg.test(self.customRate)) {
        self.dialogVisible1 = false;
        let multipleSelectionList = JSON.parse(JSON.stringify(self.multipleSelection));
        multipleSelectionList.forEach((item, index) => {
          item.rate = self.customRate / 100;
          delete item.isSet;
        });
        self.api
          .postJson('/ms-data-business-service/rate/batch-supplier-goods-rate', multipleSelectionList)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('编辑成功!');
              self.getGoodsRateList(true);
              console.log(res.data.data);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        return;
      } else {
        self.$message({
          message: '请输入数字或两位小数以内的数',
          type: 'warning',
        });
        return;
      }
    },
    //商品批量停止收费弹窗
    batchStopCharge() {
      let self = this;
      if (self.multipleSelection.length == 0) {
        self.$message.error('请先勾选数据');
        return;
      } else {
        self.dialogVisible2 = true;
      }
    },
    //批量停止收费确定
    setStopChargeDate() {
      let self = this;
      if (self.stopChargeDate == '') {
        self.$message.error('请选择时间');
        return;
      } else {
        let multipleSelectionList = JSON.parse(JSON.stringify(self.multipleSelection));
        multipleSelectionList.forEach((item, index) => {
          self.dialogVisible2 = false;
          item.chargeState = 'S';
          item.stopChargeDate = self.stopChargeDate;
          item.rate = item.rate / 100;
          delete item.isSet;
          self.api
            .postJson('/ms-data-business-service/rate/batch-supplier-goods-rate', multipleSelectionList)
            .then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('编辑成功!');
                self.getGoodsRateList(true);
              } else {
                self.$message.error(res.data);
              }
            });
        });
      }
    },
    //点击修改
    goodsEdit(row, index) {
      let self = this;
      const flag = JSON.parse(JSON.stringify(self.goodsRateData));
      self.goodsRateData = flag;
      let editData = {
        guid: row.guid,
        medName: row.medName,
        supplierRateGuid: row.supplierRateGuid,
        gppdsGuid: row.goodsGuid,
        goodsName: row.goodsName,
        rateType: row.rateType,
        rate: row.rate / 100,
        chargeState: row.chargeState,
        startChargeDate: row.startChargeDate && self.$moment(row.startChargeDate).format('YYYY-MM-DD'),
        stopChargeDate: row.stopChargeDate && self.$moment(row.stopChargeDate).format('YYYY-MM-DD'),
      };
      if (row.rateType == '1') {
        editData.rate = self.defaultRate / 100;
      } else if (row.rateType == '2') {
        editData.rate = row.rate / 100;
      } else {
        editData.rate = 0;
      }
      if (flag[index].isSet) {
        let reg = /^\d+(\.\d{1,2})?$/;
        if (flag[index].rateType == 2) {
          if (reg.test(flag[index].rate)) {
          } else {
            self.$message.warning('请输入数字或两位小数以内的数！');
            return;
          }
        }
        let startTime = self.$moment(flag[index].startChargeDate).unix();
        let endTime = self.$moment(flag[index].stopChargeDate).unix();
        console.log(endTime);
        if (endTime < startTime) {
          self.$message.error('结束日期不能比开始日期大！');
        } else {
          self.api.postJson('/ms-data-business-service/rate/update-supplier-goods-rate-info', editData).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.$message.success('编辑成功!');
              self.getGoodsRateList(false).then((res) => {
                flag[index].isSet = false;
                //self.toSaveSupplier();
              });
            } else {
              self.$message.error(res.data.msg);
            }
          });
        }
      } else {
        const isEdit = flag.some((item) => item.isSet);
        if (isEdit) {
          self.$message.error('请先保存已编辑的数据!');
        } else {
          flag[index].isSet = true;
        }
      }
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function (item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item);
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      self.getGoodsRateList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      self.getGoodsRateList();
    },
  },
};
</script>